/* unplugin-vue-components disabled */import { render } from "./ExpertAnswer.vue?vue&type=template&id=01b601ba&scoped=true"
import script from "./ExpertAnswer.vue?vue&type=script&lang=js"
export * from "./ExpertAnswer.vue?vue&type=script&lang=js"

import "./ExpertAnswer.vue?vue&type=style&index=0&id=01b601ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b601ba"]])

export default __exports__